import React, { useState } from 'react'
import "./header.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons'
import { Sunny, Moon } from 'react-ionicons'

const Header = ({ onDarkModeToggle, isDarkMode, showCustomIcon }) => {
    /*=============== Change Background Header ===============*/
    window.addEventListener("scroll", function () {
        const header = document.querySelector(".header");
        // When Scroll is higher than 560 viewport, height, add the scroll-header class to a tag with the header tag
        if (this.scrollY >= 560) header.classList.add("scroll-header");
        else header.classList.remove("scroll-header");
    });

    /*=============== Toggle Menu ===============*/
    const [Toggle, showMenu] = useState(false);
    const [activeNav, setActiveNav] = useState("#home");


    const headerClass = `header ${isDarkMode ? "dark-mode" : ""}`;


    return (
        <header className={headerClass} >
            <nav className="nav container">
                <a href="index.html" className='nav__logo'>Rizvi</a>

                <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
                    <ul className="nav__list grid">
                        <li className="nav__item">
                            <a href="#home"
                                onClick={() => setActiveNav('#home')}
                                className={activeNav === "#home"
                                    ? "nav__link active-link"
                                    : "nav__link"
                                }>
                                <i className="uil uil-estate nav__icon"></i> Home
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="#about"
                                onClick={() => setActiveNav('#about')}
                                className={activeNav === "#about"
                                    ? "nav__link active-link"
                                    : "nav__link"
                                }
                            >
                                <i className="uil uil-user nav__icon"></i> About
                            </a>
                        </li>

                        <li onClick={() => setActiveNav('#skills')}
                            className={activeNav === "#skills"
                                ? "nav__link active-link"
                                : "nav__link"
                            }>
                            <a href="#skills" className="nav__link">
                                <i className="uil uil-file-alt nav__icon"></i> Skills
                            </a>
                        </li>
                        <li onClick={() => setActiveNav('#qualification')}
                            className={activeNav === "#qualification"
                                ? "nav__link active-link"
                                : "nav__link"
                            }>
                            <a href="#qualification" className="nav__link">
                                <i className="uil uil-briefcase nav__icon"></i> Qualification
                            </a>
                        </li>
                        <li onClick={() => setActiveNav('#portfolio')}
                            className={activeNav === "#portfolio"
                                ? "nav__link active-link"
                                : "nav__link"
                            }>
                            <a href="#portfolio" className="nav__link">
                                <i className="uil uil-scenery nav__icon"></i> Portfolio
                            </a>
                        </li>

                        <li onClick={() => onDarkModeToggle()}
                            className={onDarkModeToggle === ""
                                ? "nav__link active-link"
                                : "nav__link"
                            }>
                          
                            {isDarkMode ? (
                                <>
                                 <Moon
                                    color={'#ffffff'}  
                                    title={'Moon Outline'}
                                    width={'25px'}
                                />
                                <span className="textstyle">Darkmode</span>
                                </>

                            ) 
                             : (
                                <>
                                  <Sunny
                                    color={'#00000'} 
                                    title={'Sunny Outline'}
                                />
                                  <span className="textstyle">Lightmode</span>
                                </>
                              
                            )}

                        </li>







                    </ul>




                    <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i>
                </div>

                <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
                    <i className="uil uil-apps"></i>
                </div>
            </nav>
        </header>
    )
}

export default Header
